<template>
    <div
        class="product-rating-title d-flex align-center"
        :class="{
            'justify-center': compact
        }"
    >
        <StarRating
            :rating="average ?? 0"
            :increment="0.1"
            :show-rating="false"
            :star-size="18"
            :gap="4"
            :rounded-corners="false"
            active-color="#EAAA00"
            border-color="#EAAA00"
            inactive-color="#E0E0E0"
            :border-width="0"
            readonly
        ></StarRating>
        <div
            class="product-rating-title-text font-size-7 ml-2 d-flex align-center"
        >
            <template
                v-if="total"
            >
                <span class="font-weight-bold">{{ average }}</span>
                <span
                    v-if="!hideTotal"
                    class="text-medium-emphasis ml-1"
                >&middot; {{ total }} review<template v-if="total !== 1">s</template></span>
            </template>
            <span
                v-else
                class="text-medium-emphasis"
            >No reviews</span>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import StarRating from 'x1-base/components/star-rating/StarRating/StarRating.vue';

    withDefaults(
        defineProps<{
            average: Nilish<number>;
            total: Nilish<number>;
            compact?: boolean;
            hideTotal?: boolean;
        }>(),
        {
            compact: false,
            average: 0,
            total: 0
        }
    );
</script>

<style lang="scss">
.product-rating-title {
    // The star SVGs are inline, so each star span picks up phantom line-box
    // height below the baseline and the row centers ~2px high vs the text.
    .vue-star-rating-star svg {
        display: block;
    }
}
</style>
